import { HTTPError, NormalizedOptions } from 'ky'
import { SafeResponse } from './SafeResponse'

export class EigApiError<T = unknown> extends HTTPError<T> {
  #data: T | string | undefined

  constructor(response: Response, request: Request, options: NormalizedOptions) {
    const safeResponse = new SafeResponse(response.body, response)
    super(safeResponse, request, options)

    this.#getData()
  }

  get data() {
    return new Promise<T | string | undefined>((resolve) => {
      const getData = async () => {
        await this.#getData()
        resolve(this.#data)
      }

      if (this.#data) {
        resolve(this.#data)
      } else {
        getData()
      }
    })
  }

  async #getData() {
    try {
      this.#data = await this.response.json<T>()
    } catch {
      try {
        this.#data = await this.response.text()
      } catch {
        this.#data = 'Unknown error'
      }
    }
  }
}
